import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import './assets/tailwind.css'

import PortalVue from 'portal-vue'

import { library } from '@fortawesome/fontawesome-svg-core'
//import { fas } from '@fortawesome/free-solid-svg-icons'
import { 
  faPlusCircle,
  faSearchPlus,
  faEdit,
  faEraser,
  faPencilAlt,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import 'dayjs/locale/pt-br'
import dayjs from 'dayjs'

import VueProgressBar from 'vue-progressbar'

import HasError from './components/HasError.vue'

// const optionsProgressBar = {
//   color: '#bffaf3',
//   failedColor: '#874b4b',
//   thickness: '5px',
//   transition: {
//     speed: '0.2s',
//     opacity: '0.6s',
//     termination: 300
//   },
//   autoRevert: true,
//   location: 'left',
//   inverse: false
// }
// Vue.use(VueProgressBar, optionsProgressBar)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '2px'
})

dayjs.locale('pt-br')

Vue.filter('sbformatdate', function (value) {
  if (!value) return ''
  return dayjs(value).format('DD/MM/YYYY HH:mm:ss')
})

//import VueTailwind from 'vue-tailwind'

// import TAlert from 'vue-tailwind/src/components/TAlert.vue'
// import TModal from 'vue-tailwind/src/components/TModal.vue'

// Vue.use(TAlert)
// Vue.use(TModal, {
//   //baseClass: 'border-2 p-3 relative flex',
//   footerClass: 'bg-grey-100 p-3 flex justify-between'
// })

require('@/store/subscriber')


Vue.config.productionTip = false

Vue.use(PortalVue)

Vue.component('has-error', HasError)

//library.add(fas)
library.add(faPlusCircle, faSearchPlus, faEdit, faEraser, faPencilAlt, faTrashAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)


Vue.directive('clickaway', {
  bind (el, { value }) {
    if (typeof value !== 'function') {
      console.warn(`Expect a function, got ${value}`)
      return
    }

    document.addEventListener('click', e => el.contains(e.target) || value())
  }
});


axios.defaults.baseURL = process.env.VUE_APP_API_URL;

store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})